import { ReactNode } from 'react'
import { useLazyLoading } from '../hooks/useLazyLoading'

interface LazySectionProps {
  children: ReactNode
  className?: string
  threshold?: number
  rootMargin?: string
}

const LazySection = ({ 
  children, 
  className = '', 
  threshold = 0.1, 
  rootMargin = '50px' 
}: LazySectionProps) => {
  const { elementRef, hasIntersected } = useLazyLoading({ 
    threshold, 
    rootMargin 
  })

  return (
    <div ref={elementRef} className={className}>
      {hasIntersected ? children : (
        <div className="min-h-[200px] flex items-center justify-center">
          <div className="animate-pulse bg-gray-200 rounded-lg w-full h-32"></div>
        </div>
      )}
    </div>
  )
}

export default LazySection